/* global wx */
/* global swan */
/* global androidObj */
/* global my */
/* eslint-disable func-names */
import cookies from 'js-cookie'
import { sensors } from './sensors';

export const global = {
  isLogin: false,
  populationActivityCode: '',
  populationChannelCode: '',
  userInfo: {}
}

const callbackMap = {};

export function handlerCallbackStack({type, handler}) {
  if (!handler) {
    callbackMap[type] && callbackMap[type].forEach(cur => {
      cur()
    })
  } else {
    if (callbackMap[type]) {
      callbackMap[type].push(handler);
    } else {
      callbackMap[type] = [handler];
    }
  }
}

export function isAndroid() {
  const u = navigator.userAgent;
  const android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  if (android) {
    return true
  }
  return false
}

export function isIos() {
  const u = navigator.userAgent;
  const ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (ios) {
    return true
  }
  return false
}

export function isWeixin() {
  const ua = navigator.userAgent.toLowerCase();
  const weixin = ua.match(/MicroMessenger/i) ? ua.match(/MicroMessenger/i)
    .toString() === "micromessenger" : false;
  if (weixin) {
    return true;
  }
  return false;
}

export function isBaiDu() {
  const ua = navigator.userAgent.toLowerCase();
  const isbaidu = ua.match(/baiduboxapp/i) ? ua.match(/baiduboxapp/i)
    .toString() === "baiduboxapp" : false;
  if (isbaidu) {
    return true;
  }
  return false;
}

// https://miniapp.xiaohongshu.com/docs/component/web-view
export function isXhs() {
  return navigator.userAgent.toLowerCase().includes('xhsminiapp');
}

export function isAlipayClient() {
  const ua = navigator.userAgent.toLowerCase();
  const alipayClient = ua.match(/alipayclient/i) ? ua.match(/alipayclient/i)
    .toString() === "alipayclient" : false;
  if (alipayClient) {
    return true;
  }
  return false;
}

// 判断是否是在APP内
export function openInWebview() {
  const ua = navigator.userAgent.toLowerCase()
  const Android = /com.lvyuetravel.huazhu.client_Android/i
  const IOS = /com.lvyuetravel.huazhu.client_iOS/i
  if (ua.match(Android) != null || ua.match(IOS) != null) {
    return true
  }
  return false
}

// 发出一个请求，用于与原生进行交互
export function loadURL(url) {
  let iFrame;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url);
  iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px");
  iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0");
  document.body.appendChild(iFrame);
  // 发起请求后这个 iFrame 就没用了，所以把它从 dom 上移除掉
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}

export function getQueryString(name, search) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  !search && (search = window.location.search.substr(1))
  const r = search.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

export function pxFormat(d) {
  const rem = 375 / 10;
  let val = parseFloat(d) / rem;
  val += 'rem';
  return val;
}

// 精确判断是否是在APP内 返回版本
export function openInHuazhuWebview() {
  const ua = navigator.userAgent.toLowerCase()
  const Android = /com.lvyuetravel.huazhu.client_Android/i
  const IOS = /com.lvyuetravel.huazhu.client_iOS/i;
  const Android_version = /com.lvyuetravel.huazhu.client_Android\/\S+\//i
  const IOS_version = /com.lvyuetravel.huazhu.client_iOS\/\S+\//i;
  let obj = {}
  const IOS_12 = /IPHONE OS 12_/i;
  if (ua.match(Android) != null) {
    obj.type = 'android';
    const str = ua.match(Android_version) ? ua.match(Android_version)[0] : '';
    const versionStr = str ? str.match(/\/\S+\//)[0] : null;
    let version = 0;
    if (versionStr) {
      version = versionStr.split('/')[1];
      version ? version = version.replace(/\./g, '') : 0
    }
    obj.version = version;
  } else if (ua.match(IOS) != null) {
    obj.type = 'ios';
    const str = ua.match(IOS_version) ? ua.match(IOS_version)[0] : '';
    const version = str ? str.match(/\/\S+\//)[0].replace(/\//g, '')
      .replace(/\./g, '') : 0;
    obj.version = version;
  } else {
    if (ua.match(IOS_12) != null) {
      if (ua.match(/MicroMessenger/i)
        .toString() === 'micromessenger') { // 微信浏览器判断
        return false
      } else if (ua.match(/QQ/i)
        .toString() === 'qq') { // QQ浏览器判断
        return false
      } else if (ua.match(/WeiBo/i)
        .toString() === "weibo") {
        return false
      }
      return ua.match(/safari/i) == null ? {} : false
    }
    obj = false
  }
  return obj;
}

const webpCanUse = document.createElement('canvas')
  .toDataURL('image/webp')
  .indexOf('data:image/webp') === 0

export function imgFormat(value, width, height) {
  let back = `${value}`
  if ((width && height) || webpCanUse) {
    back += `?x-oss-process=image`
    if (width && height) {
      back += `/resize,m_fill,w_${width},h_${height}`;
    }
    if (webpCanUse) {
      back += `/format,webp`
    }
  }
  return back
}

export function jumpPage(link = {
  wxUrl: '',
  baidu: '',
  alipay: '',
  android: '',
  ios: '',
  h5: '',
  XCXType: 1 // 小程序类型：1 花筑旅行 2 花粉去哪儿,默认不传则是花筑旅行
}, context, versionCallBack) {
  if (isWeixin()) { // 微信小程序
    try {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          if (link.wxUrl.indexOf('pages/index/index') > -1) {
            wx.miniProgram.switchTab({url: link.wxUrl});
          } else {
            if (link.XCXType === 2 && getQueryString('xcxType') === 'hzlx') {
              wx.miniProgram.postMessage({ // 跳转到其他小程序使用发通知的方式
                data: {
                  type: "toMini",
                  appId: 'wxf7a04d7660b61438',
                  path: link.wxUrl
                }
              })
              // 网页向小程序 postMessage 时，会在特定时机（小程序后退、组件销毁、分享）触发并收到消息。
              wx.miniProgram.navigateBack();
            } else {
              wx.miniProgram.navigateTo({url: link.wxUrl});
            }
          }
        } else {
          window.location.href = link.h5
        }
      });
    } catch (e) {
      window.location.href = link.h5
    }
  } else if (isBaiDu()) { // 百度小程序
    try {
      swan.webView.getEnv((res) => {
        if (res.smartprogram) {
          if (link.baidu.indexOf('pages/index/index') > -1) {
            swan.webView.switchTab({url: link.baidu});
          } else {
            swan.webView.navigateTo({url: link.baidu});
          }
        } else {
          window.location.href = link.h5
        }
      })
    } catch (e) {
      window.location.href = link.h5
    }
  } else if (isXhs()) {
    try {
      if (link.baidu.indexOf('pages/index/index') > -1) {
        // 也使用百度的链接
        xhs.miniProgram.switchTab({url: link.baidu});
      } else {
        // 也使用百度的链接
        xhs.miniProgram.navigateTo({url: link.baidu});
      }
    } catch (e) {
      window.location.href = link.h5
    }
  } else if (isAlipayClient()) { // 支付宝小程序
    const appId = link.XCXType === 2 ? '2021001107624185' : '2019040363776271'
    try {
      my.getEnv((res) => {
        if (res.miniprogram) {
          if (link.alipay.indexOf('pages/index/index') > -1) {
            my.switchTab({url: link.alipay});
          } else {
            if (link.XCXType === 2 && getQueryString('xcxType') === 'hzlx') {
              my.postMessage({ // 跳转到其他小程序使用发通知的方式
                data: {
                  type: "toMini",
                  appId,
                  path: link.alipay
                }
              })
            } else {
              my.navigateTo({url: link.alipay});
            }
          }
        } else {
          location.href = `alipays://platformapi/startapp?appId=${appId}&page=${link.alipay}`
        }
      })
    } catch (e) {
      location.href = `alipays://platformapi/startapp?appId=${appId}&page=${link.alipay}`
    }
  } else if (openInWebview()) { // 客户端
    if (isAndroid()) {
      if (versionCallBack) { // 安卓根据版本单独处理
        const obj = openInHuazhuWebview();
        if (obj) {
          const version = obj.version;
          if (version >= versionCallBack.version) {
            versionCallBack.androidCallBack()
          } else {
            context.$http.get(link.android);
          }
        } else {
          context.$http.get(link.android);
        }
      } else {
        context.$http.get(link.android);
      }
    } else {
      if (versionCallBack) { // ios根据版本单独处理
        const obj = openInHuazhuWebview();
        if (obj.version >= versionCallBack.version) {
          versionCallBack.iosCallBack()
        } else {
          loadURL(link.ios);
        }
      } else {
        loadURL(link.ios);
      }
    }
  } else { // h5
    window.location.href = link.h5
  }
}

/*
    * 跳转到小程序
    * 只有小程序才有的
    */
export function toXCX(context, linkUrl) {
  const wxUrl = `/${linkUrl}`
  const baidu = wxUrl
  const alipay = wxUrl
  const android = ''
  const ios = android
  const h5 = ''
  const link = {
    wxUrl, baidu, alipay, android, ios, h5
  }
  jumpPage(link, context)
}

/*
    * 跳转到首页
    */
export function toAppHome(context) {
  const wxUrl = '/pages/index/index'
  const baidu = wxUrl
  const alipay = wxUrl
  const android = 'H5_APP_DISCOUNT_BOOOK_HOTEL'
  const ios = android
  const h5 = `${process.env.MHUAZHUURL}/homePage`
  const link = {
    wxUrl, baidu, alipay, android, ios, h5
  }
  jumpPage(link, context)
}

/*
 * 跳转到详情页
 */
export function toHotelDetail(id, context) {
  const wxUrl = `/pages/hotelDetail/hotelDetail?hotelId=${id}&channel=${global.populationChannelCode}&activity=${global.populationActivityCode}`
  const baidu = wxUrl
  const alipay = wxUrl
  const android = `H5_STORE_HOUSE_SEE_HOTEL_${id}`
  const ios = android
  const h5 = `${process.env.MHUAZHUURL}/hotelDetail/${id}`
  const link = {
    wxUrl, baidu, alipay, android, ios, h5
  }
  jumpPage(link, context)
}

/*
 * 跳转到花粉去哪儿详情页
 */
export function toHuafenDetail(code, id, context) {
  const wxUrl = `/pages/detail/detail?productId=${code}&mainCategoryId=${id}`
  const baidu = wxUrl
  const alipay = wxUrl
  const XCXType = 1
  const link = {
    wxUrl, baidu, alipay, XCXType
  }
  jumpPage(link, context)
}

/*
* 跳转到列表页
*/
export function toHotelList(searchKey, searchName, regionType, context) {
  sessionStorage.setItem('searchKey', searchKey);
  sessionStorage.setItem('searchName', searchName);
  sessionStorage.setItem('searchType', regionType);

  const wxUrl = `/pages/hotelList/hotelList?searchType=${regionType}&name=${searchName}&param=${searchKey}`
  const baidu = `/pages/hotelList/hotelList?searchType=${regionType}&name=${encodeURIComponent(searchName)}&param=${searchKey}`
  const alipay = baidu
  const android = `H5_APP_DISCOUNT_BOOOK_HOTEL`
  const ios = android
  const h5 = `${process.env.MHUAZHUURL}/hotelList/`
  const link = {
    wxUrl, baidu, alipay, android, ios, h5
  }
  const versionCallBack = {
    version: 20100,
    androidCallBack() {
      androidObj.appHotelList(JSON.stringify({
        type: regionType,
        param: searchKey,
        searchContent: searchName
      }));
    },
    iosCallBack() {
      window.webkit
      && window.webkit.messageHandlers
      && window.webkit.messageHandlers.appHotelList
      && window.webkit.messageHandlers.appHotelList.postMessage
      && window.webkit.messageHandlers.appHotelList.postMessage({
        type: regionType,
        param: searchKey.toString(),
        searchContent: searchName
      });
    }
  }
  jumpPage(link, context, versionCallBack)
}


// app v2.2以后使用

export const HuazhuJsbridge = {
  callHandler(handler, params, callback) {
    const cb = `JsbridgeCallback${(new Date()).getTime()}`;
    window[cb] = callback || function () {
    };
    if (window.androidObj && window.androidObj.hasOwnProperty(handler)) {
      window.androidObj[handler](JSON.stringify(params), cb);
    }
    if (window.webkit
      && window.webkit.messageHandlers
      && window.webkit.messageHandlers.hasOwnProperty(handler)) {
      window.webkit.messageHandlers[handler].postMessage({json: params, cb});
    }
  }
}

/*
* 登录
*/
export function login(callback, cbWebview) {
  sensors.track('registerButtonClick', {
    login_entrance: document.title,
    platformType: 'h5'
  });
  if (openInWebview()) {
    const obj = openInHuazhuWebview();
    if (isAndroid()) {
      if (obj) {
        const version = obj.version;
        if (version >= 220) {
          HuazhuJsbridge.callHandler('appLogin', {
            pagePosition: "立即登录",
            loginEntrance: document.title
          }, (jsonStr) => {
            try {
              const userObj = JSON.parse(jsonStr);
              if (userObj.state) {
                cookies.set('ows_token', userObj.token, {
                  domain: '.lvyuetravel.com',
                  expires: 15 * 60 * 1000,
                  path: '/'
                });
                global.isLogin = true
                cbWebview()
              }
            } catch (e) {
              console.log(e)
            }
          })
        } else if (version >= 202) {
          androidObj.toLogin('立即登录', document.title);// page_positon login_entrance
        } else {
          androidObj.toLogin();
        }
      } else {
        try {
          androidObj.toLogin();
        } catch (e) {
          console.log(e)
        }
      }
    } else {
      if (obj) {
        const version = obj.version;
        if (version >= 220) {
          HuazhuJsbridge.callHandler('appLogin', {
            pagePosition: "立即登录",
            loginEntrance: document.title
          }, (jsonStr) => {
            try {
              const userObj = JSON.parse(jsonStr);
              if (userObj.state) {
                cookies.set('ows_token', userObj.token, {
                  domain: '.lvyuetravel.com',
                  expires: 15 * 60 * 1000,
                  path: '/'
                });
                global.isLogin = true
                cbWebview()
              }
            } catch (e) {
              console.log(e)
            }
          })
        } else {
          loadURL("H5_APP_DISCOUNT_UNLOGIN_HOTEL")
        }
      } else {
        loadURL("H5_APP_DISCOUNT_UNLOGIN_HOTEL")
      }
    }
  } else {
    if (isWeixin()) {
      try {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram.redirectTo({url: `/pages/login/login?target=${window.location.href}`});
          } else {
            callback()
          }
        })
      } catch (e) {
        callback()
      }
    } else if (isBaiDu()) {
      try {
        swan.webView.getEnv((res) => {
          if (res.smartprogram) {
            swan.webView.redirectTo({url: `/pages/login/login?target=${window.location.href}`});
          } else {
            callback()
          }
        })
      } catch (e) {
        callback()
      }
    } else if (isAlipayClient()) {
      try {
        my.getEnv((res) => {
          if (res.miniprogram) {
            my.redirectTo({url: `/pages/login/login?target=${window.location.href}`});
          } else {
            callback()
          }
        })
      } catch (e) {
        callback()
      }
    } else {
      callback()
    }
  }
}

/*
* 跳转判断
*/
export function goUrl(linkUrl, context) {
  if (linkUrl) {
    const search = linkUrl.split('?')[1]
    if (linkUrl.indexOf('pages/index/index') > -1) { // 内部跳转-首页
      toAppHome(context)
    } else if (linkUrl.indexOf('pages/hotelDetail/index') > -1) { // 内部跳转-详情页
      const id = getQueryString('hotelId', search)
      toHotelDetail(id, context)
    } else if (linkUrl.indexOf('pages/hotelList/index') > -1) { // 内部跳转-列表页
      const searchKey = getQueryString('searchKey', search)
      const searchName = getQueryString('searchName', search)
      const searchType = getQueryString('searchType', search)
      toHotelList(searchKey, searchName, searchType, context)
    } else if (!isExternal(linkUrl)) {
      toXCX(context, linkUrl)
    } else { // 跳其他链接 replace
      window.location.href = linkUrl
    }
  }
}

/*
* 格式化评分
*/
export function scoreFormat(val) {
  const len = val.toString()
    .split('.').length
  return len > 1 ? val : `${val}.0`
}

/*
* 复制
*/
export function copyToClipboard(element, cb) {
  const editable = element.hasAttribute('contenteditable');
  const selection = window.getSelection();
  const {nodeName} = element;
  if (nodeName === 'SELECT') {
    element.focus();
  } else if (nodeName === 'TEXTAREA' || nodeName === 'INPUT') {
    element.select();
  } else {
    if (!editable) {
      element.setAttribute('contenteditable', true);
    }
    // element.focus();
    const range = document.createRange();

    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }
  document.execCommand('copy');
  element.blur();
  element.setAttribute('contenteditable', editable);
  selection.removeAllRanges();
  if (cb) {
    cb();
  }
}

/*
* 根据选择的国家码返回控制手机号长度
* */
export function changeAreaCode(val, cb) {
  const country = val[0].split("-")[0];
  let num;
  switch (country) {
    case '852':
    case '853':
    case '65':
      num = 8;
      break;
    case '886':
    case '66':
      num = 9;
      break;
    case '60':
    case '81':
    case '82':
      num = 10;
      break;
    case '86':
      num = 11;
      break;
    default:
      num = 10
  }
  cb(country, num)
}

/*
* 是不是超链接
* */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}


export function debounce(fn, wait, immediate) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer)
    if (immediate && !timer) {
      fn.apply(this, args)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, wait)
  }
}

export function throttle(func, delay) {
  let prev = Date.now();
  return function (...args) {
    const context = this;
    const now = Date.now();
    if (now - prev >= delay) {
      func.apply(context, args);
      prev = Date.now();
    }
  }
}

export const getTouchType = () => getQueryString('goldmineMsgId') || getQueryString('pushId') || '运营位'
export const getSuperiorPage = () => {
  if (getQueryString('goldmineMsgId')) {
    return '短信'
  } else if (getQueryString('pushId')) {
    return 'push'
  }
  return 'banner'
}

export const isElementInViewport = el => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <=
    (window.innerWidth || document.documentElement.clientWidth)
  );
}



// WEBPACK FOOTER //
// ./src/common/util.js